/* eslint-disable */

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

import MediaModal from "components/MediaModal";

function Default() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <>
        <MediaModal />
      </>
      <Footer />
    </DashboardLayout>
  );
}

export default Default;
